import React, { useEffect, useState } from "react";
import { api, formatApiError, todayISO } from "../lib/api";
import { toast } from "sonner";
import { FileDown } from "lucide-react";

export default function DailyClosing() {
  const [date, setDate] = useState(todayISO());
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async (d) => {
    setLoading(true);
    try {
      const { data } = await api.get(`/stock/daily-closing?date=${d}`);
      setRows(data.rows || []);
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(date); }, []);

  const downloadCsv = () => {
    const header = "Godown,Brand,Size,Filled,MT\n";
    const body = rows.map((r) => `${r.godown},${r.brand},${r.size},${r.filled},${r.mt}`).join("\n");
    const blob = new Blob([header + body], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `closing_stock_${date}.csv`; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-6">
      <div className="card-flat p-5 flex items-center gap-4 flex-wrap">
        <div>
          <label className="small-label block mb-2">Date</label>
          <input type="date" className="input-lg w-[200px]" value={date}
            onChange={(e) => setDate(e.target.value)} data-testid="closing-date" />
        </div>
        <button className="btn-primary h-11 mt-6" onClick={() => load(date)} data-testid="closing-load">Refresh</button>
        <button className="ml-auto mt-6 border border-gray-300 px-4 h-11 rounded-sm flex items-center gap-2 font-semibold hover:bg-gray-50"
          onClick={downloadCsv} data-testid="closing-csv">
          <FileDown size={16} /> Download CSV
        </button>
      </div>

      <div className="card-flat">
        <div className="p-4 border-b border-gray-200 small-label text-gray-500">Closing stock as of {date}</div>
        <div className="table-wrap">
        <table className="table-dense w-full">
          <thead>
            <tr>
              <th className="text-left">Godown</th><th className="text-left">Brand</th>
              <th className="text-left">Size</th><th className="num">Filled</th><th className="num">MT</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan="5" className="py-4 text-center">Loading…</td></tr>}
            {!loading && rows.map((r, i) => (
              <tr key={i}>
                <td className="font-semibold">{r.godown}</td>
                <td>{r.brand}</td><td>{r.size}</td>
                <td className="num"><span className={`inline-block px-2 py-0.5 rounded-sm ${r.filled > 0 ? "stock-filled" : "text-gray-400"}`}>{r.filled}</span></td>
                <td className="num"><span className={`inline-block px-2 py-0.5 rounded-sm ${r.mt !== 0 ? "stock-mt" : "text-gray-400"}`}>{r.mt}</span></td>
              </tr>
            ))}
            {!loading && rows.length === 0 && <tr><td colSpan="5" className="py-8 text-center text-gray-400">No stock</td></tr>}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
}
